import { IGameInfoDto } from 'modules/stream/domain/interfaces/game-info/game-info-dto';
import { parseResponseError } from 'shared/utils';
import graphqlResource from '../../../core/graphql-resource';
import { gameInfoDataMapper } from '../mappers/game-info-data-mapper';

export interface IGameInfoResponseDto {
  data: {
    match: IGameInfoDto;
  };
  errors?: any;
}

async function getGameInfo(matchId: number) {
  const query = `#graphql
      query getGameDetails($id: Int!) {
        match(id: $id) {
          id
          date
          location {
            name
            address {
              city
              country
              region
            }
          }
          tournament {
            id
            name
            images { externalUrl }
            address {
              city
            }
          }
          championship {
            id
            name
            settings { id name value }
            championshipTable {
              rows {
                team {
                  id
                  name
                }
                lastGamesResults { result }
              }
            }
          }
          teamMatches {
            team {
              id
              name
              emblem {
                externalUrl
              }
              members {
                number
                position
                user {
                  id
                  photo { url: externalUrl }
                  name
                  surname
                  middleName
                }
              }
              championshipApplications {
                championship { id }
                state
                number
                position
                user {
                  id
                  name
                  surname
                  middleName
                }
              }
            }
          }
          participants {
            id
            match { id }
            user { id }
            isInvolved
          }
        }
      }
    `;

  const response = await graphqlResource.query<IGameInfoResponseDto>(query, { id: matchId });

  if (response.data.errors) {
    throw new Error(parseResponseError(response.data.errors[0]));
  }

  return gameInfoDataMapper(response.data.data.match);
}

export default getGameInfo;
